<template>
  <div class="RightClaim">
    <SpTagGroup v-model="formData.type">
      <SpTag :label="1">{{ $l('OwnedCargo') }}</SpTag>
      <SpTag :label="2">{{ $l('OPCargo') }}</SpTag>
    </SpTagGroup>
    <SpForm v-model="formData" @submit="submit">
      <SpTable :data-list="tableData">
        <SpTableColumn label="CargoNameforTrade" column-name="name" />
        <SpTableColumn label="IMSBCCODE" column-name="imsbcCode" :width="160" />
        <SpTableColumn label="TBUnit" column-name="tbUnit" />
        <SpTableColumn label="PackingMethod" column-name="packingMethod" :width="180" />
        <SpTableColumn label="PackingDimension" column-name="packingDimensionDesc" />
        <SpTableColumn label="OBUnit" column-name="obUnit" />
        <SpTableColumn label="SF" column-name="SF">
          <template #default="row">
            <div v-if="row.extInput?.sf?.dwt" style="line-height: 100px">
              DWT
            </div>
            <div v-else-if="row.extInput?.sf?.aboutCbm" class="mg-t-20">
              {{ row.sfMin }} - {{ row.sfMax }}
              <p>
                {{ row.extInput?.sf?.aboutCbm }}
              </p>
            </div>
            <div v-else-if="row.extInput?.sf?.aboutCbft" class="mg-t-20">
              {{ row.extInput?.sf?.cbftMin }} - {{ row.extInput?.sf?.cbftMax }}
              <p>
                {{ row.extInput?.sf?.aboutCbft }}
              </p>
            </div>
            <div v-else>{{ row.sfMin }} - {{ row.sfMax }}</div>
          </template>
        </SpTableColumn>
        <SpTableColumn label="WF" column-name="WF">
          <template #default="row">
            <div class="sf-wf-column">{{ row.wfMin }}</div>
          </template>
        </SpTableColumn>
        <SpTableColumn label="WF" column-name="WF">
          <template #default="row">
            <div class="sf-wf-column">{{ row.wfMax }}</div>
          </template>
        </SpTableColumn>
        <SpTableColumn column-name="More">
          <template #default="row">
            <SpIcon :ref="(el)=>bindRef(row.$index,el)" type="more" @click="showMore = true, checkItem=row " />
          </template>
        </SpTableColumn>
      </SpTable>
      <SpDrawer v-model="showMore" dragable :offset-top="20" width="0.98" height="0.8">
        <CargoMore :cargo-id="checkItem.id" />
      </SpDrawer>

      <OwnedCargo v-show="formData.type===1" :can-operated="canOperated" :form-data="formData" :options="ownerShipType.sovereign" :companies="companies" @openOp="openOp" />
      <OPCargo v-show="formData.type==2" :can-operated="canOperated" :form-data="formData" :options="ownerShipType.op" :companies="companies" @openOp="openOp" />
    </SpForm>

    <el-dialog
      v-model="dialogVisible"
      width="500px"
      top="35vh"
      :before-close="handleClose"
    >
      <div style="line-height: 30px; color: #000">
        Congratulations on the successful confirmation of rights, <br>
        go directly to edit Cargo Order now?
      </div>
      <template #footer>
        <div class="dialog-footer" style="display: block">
          <div class="flex flex-al-end pd-l-80 pd-r-80">
            <div class="flex-1">
              <router-link :to="{name:'cargoCollection'}">
                <SpButton circle="4" type="cancleLight" height="42px" width="120px">No</SpButton>
              </router-link>
            </div>
            <div style="width: 120px">
              <router-link :to="{name:'cargoOrderEdit',query:{id:formData.cargoId}}">
                <SpButton circle="4" type="confirm" height="42px" width="120px">
                  Yes
                </SpButton>
              </router-link>
            </div>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import SpTagGroup from '@/components/common/SpTagGroup.vue'
import SpTag from '@/components/common/SpTag.vue'
import SpTable from '@/components/common/SpTableDIY/SpTable.vue'
import SpTableColumn from '@/components/common/SpTableDIY/SpTableColumn.vue'
import SpIcon from '@/components/common/SpIcon.vue'
import OwnedCargo from './OwnedCargo.vue'
import OPCargo from './OPCargo.vue'
import SpButton from '@/components/common/SpButton.vue'
import { reactive, ref } from 'vue'
import {
  cargoOwnershipApplyApi,
  getCargoDetailApi,
  getCargoOwnerApi,
  getCargoOwnershipTypeApi
} from '@/request/APIs/co'
import { useRouter } from 'vue-router'
import SpForm from '@/components/common/SpForm'
import { completeFile, uploadFile } from '@/request/APIs/file'
import SpMessage from '@/components/common/SpMessage'
import { nextTick } from '@vue/runtime-core'
import { CARGO_OWNER_STATUS_NOT_APPLY } from '@/config/cargo'
import SpDrawer from '@/components/common/SpDrawer'
import CargoMore from '@/components/cargoOwner/cargo/cargoCollection/CargoMore'
export default {
  name: 'RightClaim',

  nameSpace: 'cargoOwner.cargo.RightClaim',

  components: {
    CargoMore,
    SpDrawer,
    SpForm,
    SpTagGroup,
    SpTag,
    SpTable,
    SpTableColumn,
    SpIcon,
    OwnedCargo,
    OPCargo,
    SpButton
  },

  props: {
  },

  setup (props, ctx) {
    const dialogVisible = ref(false)
    const tableData = ref([])
    const router = useRouter()
    const canOperated = ref(true)

    const openOp = () => {
      canOperated.value = true
    }
    // 获取货物信息
    const getCargoDetail = (cargoId) => {
      getCargoDetailApi(cargoId).then(res => {
        formData.type = [-3, -2, -1, 1].includes(res.data.ownershipStatus) ? 1 : 2
        tableData.value = [res.data]
        formData.ownership = res.data.ownership
        const ownershipDetails = res.data.ownership?.details || []
        formData.ownershipStatus = res.data.ownershipStatus

        if (res.data.ownershipStatus === CARGO_OWNER_STATUS_NOT_APPLY) {
          canOperated.value = true
        }

        // 自有
        if (res.data.ownershipStatus === 1) {
          ownershipDetails.forEach((item) => {
            const index = formData.sovereignOwnerships.findIndex(o => o.id === item.ownershipTypeId)
            formData.sovereignOwnerships[index] = {
              corpIds: Object.keys(item.ownershipCorpIds),
              typeId: item.ownershipTypeId
            }
          })
        }
        // op 货
        if (res.data.ownershipStatus === 2) {
          ownershipDetails.forEach((item) => {
            const index = formData.opOwnerships.findIndex(o => o.id === item.ownershipTypeId)
            formData.opOwnerships[index] = {
              corpIds: Object.keys(item.ownershipCorpIds),
              typeId: item.ownershipTypeId,
              activatedDate: item.activatedDate,
              expiredDate: item.expiredDate
            }
          })
        }
      })
    }

    const ownerShipType = reactive({ sovereign: [], op: [] })

    const getCargoOwnershipType = getCargoOwnershipTypeApi()
    const getCargoOwner = getCargoOwnerApi()

    // 获取货产权方式选项
    const initializeCargoOwnershipType = (res) => {
      if (res.code === 1) {
        ownerShipType.sovereign = Object.values(res.data.sovereign)
        ownerShipType.op = Object.values(res.data.op)

        ownerShipType.sovereign.forEach(item => {
          formData.sovereignOwnerships.push({ id: item.id })
        })
        ownerShipType.op.forEach(item => {
          formData.opOwnerships.push({ id: item.id })
        })
      }
    }

    const companies = ref([])// 产权公司（下拉选择项）
    const initializeCargoOwner = (res) => {
      companies.value = Object.keys(res.data).map(key => ({
        value: key,
        label: res.data[key]
      }))
    }

    Promise.all([getCargoOwnershipType, getCargoOwner]).then(res => {
      initializeCargoOwnershipType(res[0])
      initializeCargoOwner(res[1])
    }).then(() => {
      getCargoDetail(router.currentRoute.value.query.id)
    })

    const formData = reactive({ type: 1, stop: 0, sovereignOwnerships: [], opOwnerships: [] })// 表单数据
    // 提交事件
    const submit = (form) => {
      const formDatas = form.data
      formDatas.stop = formDatas.stop || 0
      formDatas.type = formData.type
      if (formDatas.type === 1) {
        formDatas.ownerships = formDatas.sovereignOwnerships
      } else {
        formDatas.ownerships = formDatas.opOwnerships
      }
      formDatas.id = router.currentRoute.value.query.id
      delete formDatas.sovereignOwnerships
      delete formDatas.opOwnerships
      cargoOwnershipApplyApi(formDatas).then(res => {
        if (res.code === 1) {
          formData.businessId = res.data.id
          formData.cargoId = router.currentRoute.value.query.id

          // 上传文件
          nextTick(() => {
            form.uploadAllFile().then(() => {
              completeFile({
                type: 'ownership/cargo/editing/completed',
                id: res.data.id
              }).then(() => {
                SpMessage.success('Right claim succeed!')
                if (parseInt(formData.stop) === 1) {
                  router.push({
                    name: 'cargoCollection'
                  })
                  return
                }
                dialogVisible.value = true
              }).catch(() => {
                SpMessage.error('Editing complete failed!')
              })
            }).catch(e => {
              SpMessage.error('File upload failed!')
            })
          })
        } else {
          SpMessage.error(res.message)
        }
      })
    }

    const refs = ref([])

    const bindRef = (index, el) => {
      refs.value[index] = el
    }
    const showMore = ref(false)
    const popupTrigger = ref(0)
    const checkItem = ref({})
    return {
      showMore,
      popupTrigger,
      checkItem,
      tableData,
      formData,
      ownerShipType,
      submit,
      companies,
      canOperated,
      openOp,
      refs,
      bindRef,
      dialogVisible
    }
  }
}
</script>

<style scoped lang="less">
.RightClaim{
  padding: @gap;
}
</style>

<style>
a {
  /*color: -webkit-link;*/
  cursor: pointer;
  text-decoration: none;
}
</style>
